<template>
  <div class="replenishment">
    <!-- 添加买家 -->
    <md-popup v-model="show" :mask-closable="false">
      <md-popup-title-bar title="补货" :only-close="true" @cancel="cancelPop()"></md-popup-title-bar>
      <div class="pop_content" v-if="item">
          <md-field>
            <div class="goods_name">
              <div>
                {{item.name}}
              </div>
              <span class="goods_item_type">
                <span class="goods_item_type_1" v-if="item.bale ==1">定装</span>
                <span class="goods_item_type_2" v-if="item.bale ==2">非定装</span>
                <span class="goods_item_type_3" v-if="item.bale ==3">散装</span>
              </span>
            </div>
            <md-input-item v-if="item.bale == 1 || item.bale == 2 " title="数量" clearable type="text" v-model="subData.num" placeholder="请输入货品数量">
              <template slot="right">
                {{unit_list[item.num_unit - 1].name}}
              </template>
            </md-input-item>
            <md-input-item v-if="item.bale == 3 || item.bale == 2" title="重量" clearable type="text" v-model="subData.weight" placeholder="请输入货品重量">
              <template slot="right">
                公斤
              </template>
            </md-input-item>
            <md-input-item title="货款" clearable type="text" v-model="subData.amount" placeholder="请输入货款">
              <template slot="right">
                元
              </template>
            </md-input-item>
          </md-field>
          <div class="pop_btns">
            <md-button type="warning" plain size="small" inline @click="cancelPop()">取消</md-button>
            <md-button type="primary" size="small" inline @click="submitData">保存</md-button>
          </div>
      </div>
    </md-popup>

  </div>
</template>

<script>
import { goodsReplenish_handle } from "@/api/work/stock";
import { isNumFloat,isPosFloat } from "@/utils/validate";
export default {
  name: 'replenishment',
  data(){
    return {
      loading:true,
      show:false,
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      item:null,
      subData:{
        batch:'',
        num:'',
        weight:'',
        amount:'',
      },
    }
  },
  created(){
    
  },
  mounted(){




  },
  methods:{
    // 显示弹窗
    showPop(item){
      this.item = item
      this.subData.batch = item.batch
      this.show = true
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 取消弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData = {
        batch:'',
        num:'',
        weight:'',
        amount:'',
      }
      this.item = null
    },
    // 提交数据
    submitData(){ 
      if(!this.loading){
        return false
      }
      if((this.item.bale == 1 || this.item.bale == 2) && (!isPosFloat(this.subData.num) || this.subData.num == 0) ){this.$toast.info("请输入补货数量！"); return false }
      if((this.item.bale == 2 || this.item.bale == 3) && (!isPosFloat(this.subData.weight) || this.subData.weight == 0)){this.$toast.info("请输入补货重量！"); return false }
      if( (!isPosFloat(this.subData.amount) || this.subData.amount == 0)){this.$toast.info("请输入货款！"); return false }
      this.loading = false
      goodsReplenish_handle(this.subData).then(res=>{
        this.$toast.succeed(res.message)
        this.loading = true
        this.finishPop()
      }).catch(err=>{
        this.loading = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.replenishment{
  position: relative;
  // 添加买家模块
  .pop_content {
    width: 5rem;
    // height: 6rem;
    background-color: #fff;
    border-radius:0 0 0.08rem 0.08rem;
    overflow: hidden;
    padding:0 0.2rem;
    position: relative;
    .goods_name{
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      margin: 0.25rem 0;
      &>div{
        font-size: 0.28rem;
        font-weight: bold;
      }
    }
    .pop_btns{
      padding: 0.15rem 1rem 0.2rem;
      padding-top: 0.6rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>